import React, { useState, useEffect } from 'react';
import { Button, CircularProgress, Typography, Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { useSnackbar } from 'notistack';

import PatientsList from './components/PatientsList';
import BookAppointmentModal from './components/BookAppointmentModal';
import PatientTrackingModal from './components/PatientTracking';
import PatientProfileModal from './components/PatientProfileModal';
import ConsultNoteEditModal from '../../components/ConsultNoteEditModal';
import PatientSearchBar from '../../components/PatientSearchBar';
import MergePatientModal from './components/MergePatientModal';
import NoticeDialog from '../../components/DialogModals/NoticeDialog';

import {
  fetchPatientsPage,
  createConsultNote,
  updatePatient,
  createPatient,
} from '../../services/api';

function ProviderAdminPatients(props) {
  const {
    history,
    classes: {
      loading,
      root,
      header,
      headerText,
      list,
      actions,
      button,
      mergeButton,
      btnResponsive,
      paddingZero,
    },
  } = props;

  const { enqueueSnackbar } = useSnackbar();
  const [patients, setPatients] = useState([]);
  const [patientUnderEdit, setPatientUnderEdit] = useState({});
  const [openAppointmentModal, setOpenAppointmentModal] = useState(false);
  const [openTrackingModal, setOpenTrackingModal] = useState(false);
  const [openNewPatientsModal, setOpenNewPatientsModal] = useState(false);
  const [openConsultNotesModal, setOpenConsultNotesModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [usersSearchTerm, setUsersSearchTerm] = useState('');
  const [openMergePatientsModal, setOpenMergePatientsModal] = useState(false);
  const [patientsForMerge, setPatientsForMerge] = useState([]);
  const [mergeMode, setMergeMode] = useState(false);
  const [selectNotice, setSelectNotice] = useState(false);

  useEffect(() => {
    fetchPatients();
  }, []);

  const fetchPatients = async (searchTerm = null, pageIndex = 0) => {
    try {
      setIsLoading(true);
      const page = await fetchPatientsPage({
        searchTerm,
        limit: 20,
        offset: 20 * pageIndex,
        practiceId: 'currentUsersPracticeId',
        tolerance: 5,
      });
      setPatients(page);
    } catch (err) {
      enqueueSnackbar('Unable to fetch patients, please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const onBookAppointment = patient => {
    setPatientUnderEdit(patient);
    setOpenAppointmentModal(true);
  };

  const onTrackPatient = patient => {
    let note = {patient}
    setPatientUnderEdit(note);
    setOpenTrackingModal(true);
  };

  const onEditPatient = patient => {
    setPatientUnderEdit(patient);
    setOpenNewPatientsModal(true);
  };

  const onSendConsultNote = patient => {
    setPatientUnderEdit(patient);
    setOpenConsultNotesModal(true);
  };

  const onNewPatient = () => {
    setPatientUnderEdit({});
    setOpenNewPatientsModal(true);
  };

  const onDialogClose = () => {
    setPatientUnderEdit({});
    setOpenTrackingModal(false);
    setOpenAppointmentModal(false);
    setOpenNewPatientsModal(false);
    setOpenConsultNotesModal(false);
  };

  const onCreatePatient = async patient => {
    try {
      let data = await createPatient(patient);
      fetchPatients();
      if (data) enqueueSnackbar('Patient created!');
    } catch {
      enqueueSnackbar('Oops, something went wrong. Please Try again');
    }
  };

  const onUpdatePatient = async patient => {
    try {
      const nextPatient = await updatePatient(patient);
      setPatientUnderEdit(nextPatient);
      fetchPatients();
      enqueueSnackbar('Patient updated!');
    } catch {
      enqueueSnackbar('Oops, something went wrong. Please Try again');
    }
  };

  const sendConsultNote = async noteParams => {
    try {
      await createConsultNote(noteParams);
      onDialogClose();
      enqueueSnackbar('Successfully sent note!');
    } catch (err) {
       enqueueSnackbar('Unable to send note. Please try again.');
    }
  };

  const onPageChange = pageIndex => {
    fetchPatients(usersSearchTerm, pageIndex);
  };

  const handleSelectPatientToSearch = patient => {
    if (patient) {
      const name = `${patient.firstName} ${patient.lastName}`;
      fetchPatients(name);
    }
  };

  const handleUserEditingSearchTerm = searchTerm => {
    setUsersSearchTerm(searchTerm);
  };

  const onMergePatient = () => {
    if (patientsForMerge.length > 1) {
      setOpenMergePatientsModal(true);
    } else {
      setSelectNotice(true);
    }
  };

  return isLoading ? (
    <div className={loading}>
      <CircularProgress />
    </div>
  ) : (
            <div className="paddingZero">
        <div className="paddingZero">
      <div className={root}>
        <header className={header}>
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h2" className={headerText}>
                Patients
            </Typography>
            </Grid>
            <Grid item>
        <div className = "myPatientsBtn">
              <div className={actions}>
              
                <Button
                  className={button}
                  color="primary"
                  variant="contained"
                  onClick={onNewPatient}
                >
                  Add New Patient
              </Button>
                <Button
                  className={button}
                  color="primary"
                  variant="contained"
                  title={
                    mergeMode ? 'Close patient selctor' : 'Open patient selector'
                  }
                  onClick={() => {
                    setMergeMode(mergeMode ? false : true);
                    setPatientsForMerge([]);
                  }}
                >
                  Merge Patients
              </Button>
                {mergeMode && (
                  <Button
                    className={mergeButton}
                    color="primary"
                    variant="contained"
                    title="Proceed to finalize merge"
                    onClick={onMergePatient}
                  >
                    Continue merging
                  </Button>
                )}
              </div>
              </div>
            </Grid>
          </Grid>
        </header>
          </div>
        </div>

        <PatientSearchBar
          fullWidth
          label="Search"
          onSelect={handleSelectPatientToSearch}
          onChange={handleUserEditingSearchTerm}
        />
        <div className={list}>
          <PatientsList
            history={history}
            patients={patients}
            onPageChange={onPageChange}
            onEditPatient={onEditPatient}
            onBookAppointment={onBookAppointment}
            onSendConsultNote={onSendConsultNote}
            patientsForMerge={patientsForMerge}
            setPatientsForMerge={setPatientsForMerge}
            onTrackPatient={onTrackPatient}
            mergeMode={mergeMode}
          />
        <div className = "myPatientsBtn">
          <div className={actions}>
            <Button
              className={button}
              color="primary"
              variant="contained"
              onClick={onNewPatient}
            >
              Add New Patient
          </Button>
            <Button
              className={button}
              color="primary"
              variant="contained"
              title={
                mergeMode ? 'Close patient selctor' : 'Open patient selector'
              }
              onClick={() => {
                setMergeMode(mergeMode ? false : true);
                setPatientsForMerge([]);
              }}
            >
              Merge Patients
          </Button>
            {mergeMode && (
              <Button
                className={mergeButton}
                color="primary"
                variant="contained"
                title="Proceed to finalize merge"
                onClick={onMergePatient}
              >
                Continue merging
              </Button>
            )}
          </div>
          </div>
          {openAppointmentModal && (
            <BookAppointmentModal
              open={openAppointmentModal}
              patient={patientUnderEdit}
              closeDialog={onDialogClose}
            />
          )}

          {openTrackingModal && (
            <PatientTrackingModal
              open={openTrackingModal}
              note={patientUnderEdit}
              closeDialog={onDialogClose}
            />
          )}

          {openNewPatientsModal && (
            <PatientProfileModal
              open={openNewPatientsModal}
              patient={patientUnderEdit}
              createPatient={onCreatePatient}
              updatePatient={onUpdatePatient}
              onClose={onDialogClose}
            />
          )}

          {openConsultNotesModal && (
            <ConsultNoteEditModal
              patient={patientUnderEdit}
              open={openConsultNotesModal}
              save={sendConsultNote}
              onClose={onDialogClose}
            />
          )}
          {openMergePatientsModal && (
            <MergePatientModal
              open={openMergePatientsModal}
              history={history}
              patientsForMerge={patientsForMerge}
              setPatientsForMerge={setPatientsForMerge}
              setOpenMergePatientsModal={setOpenMergePatientsModal}
              fetchPatients={fetchPatients}
              setMergeMode={setMergeMode}
            />
          )}
          {selectNotice && (
            <NoticeDialog
              noticeTitle={'Patient Merge'}
              message={'Please select at least two patients to merge.'}
              open={selectNotice}
              onOkClick={() => setSelectNotice(false)}
            />
          )}
        </div>
      </div>
    );
}

const styles = () => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  root: {
    padding: '3em',
  },
  header: {
    paddingBottom: '3em',
  },
  headerText: {
    fontWeight: 'normal',
    fontSize: '1.8em',
    lineHeight: '19px',
    color: '#1C1C1C',
  },
  list: {
    paddingBottom: '2em',
  },
  actions: {
    textAlign: 'right',
  },
  button: {
    marginLeft: '20px',
  },
  mergeButton: {
    marginLeft: '20px',
    color: 'black',
    backgroundColor: '#FFF6BF',
    '&:hover': {
      marginLeft: '20px',
      color: 'black',
      backgroundColor: '#cdc48d',
    },
  },
});

export default withStyles(styles)(ProviderAdminPatients);
